import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { FwIconColor } from '../../../shared/types/fw-icon-color.type';
import { StatusChipType } from './status-chip.enums';

@Component({
  host: { 'test-id': 'operation-status' },
  selector: 'status-chip',
  styleUrls: ['./status-chip.component.scss'],
  templateUrl: './status-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusChipComponent implements OnChanges {
  @Input() status: StatusChipType;
  @Input() tooltipText = '';
  @Input() title = '';

  protected readonly statuses = StatusChipType;
  protected statusColor: FwIconColor;
  protected statusIcon: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status?.currentValue) {
      this.statusColor = this.getStatusColor(this.status);
      this.statusIcon = this.getStatusIcon(this.status);
    }
  }

  private getStatusColor(status: StatusChipType): FwIconColor {
    switch (status) {
      case StatusChipType.Completed:
        return 'green';
      case StatusChipType.Cancelled:
        return 'muted';
      case StatusChipType.Failed:
        return 'red';
      default:
        return 'primary';
    }
  }

  private getStatusIcon(status: StatusChipType): string {
    switch (status) {
      case StatusChipType.Completed:
        return 'done-check-tracked';
      case StatusChipType.Cancelled:
        return 'close';
      case StatusChipType.Failed:
        return 'close-circled';
      default:
        return 'rotate-refresh';
    }
  }
}

